/**
 * Имя CSRF-cookie зависит от СХЕМЫ `APP_URL`, а не от NODE_ENV: `__Host-mm_csrf` на https
 * (прод), `mm_csrf` на http (локальная разработка) — server/lib/auth/cookies.ts:22-35.
 * Причина в самом префиксе: `__Host-` требует атрибута Secure, а Safari не принимает
 * Secure-cookie по http://localhost.
 *
 * Клиент схему заранее не знает: в бандл на сборке вшивается только SITE_LANGUAGE, не APP_URL.
 * Поэтому читаются ОБА имени. Захардкодить одно — молча сломать одно из двух окружений.
 *
 * ⚠️ Не путать с refresh-cookie `mm_rt`/`__Host-mm_rt`: та httpOnly и из JS не читается
 * в принципе. Здесь читается только CSRF-cookie, которая намеренно БЕЗ httpOnly —
 * именно чтобы SPA могла её прочитать.
 */
function readNamedCookie(name: string): string | null {
  const prefix = `${name}=`;
  for (const part of document.cookie.split('; ')) {
    if (part.startsWith(prefix)) return decodeURIComponent(part.slice(prefix.length));
  }
  return null;
}

export function readCsrfCookie(): string | null {
  return readNamedCookie('__Host-mm_csrf') ?? readNamedCookie('mm_csrf');
}

/** Админское пространство токенов: mm_acsrf — это CSRF, а mm_art — refresh. Разные cookie. */
export function readAdminCsrfCookie(): string | null {
  return readNamedCookie('__Host-mm_acsrf') ?? readNamedCookie('mm_acsrf');
}
